<template>
  <div class="new-award" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }"
    v-if="is_show"
    >
    <img :src="cc.bg_img" alt="" class="bg">
    <div @click="receive" class="receive-btn" :style="{'background-image': `url(${btn_bg})`, 'color': gc.text_color}">
      {{btn_desc}}
    </div>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin'
import { recruit } from '_api/activity-common-template'
import { utils } from '_lib/utils'

export default {
  name: 'cpt-new-award',
  mixins: [ComponentCommonMixin],
  data () {
    return {
      state: 1,
      is_show: false
    }
  },
  computed: {
    btn_bg () {
      if (this.state != 1 ) {
        return this.gc.modal_confirm_btn_small
      }
      return this.gc.modal_cancel_btn
    },
    btn_desc () {
      if (this.state != 1 ) {
        return '领取'
      }
      return '已领取'
    }
  },
  mounted () {
    this.state = this.cd.state
    this.is_show = this.cd.hasOwnProperty('state')
  },
  methods: {
    receive () {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      recruit({
        act_id: this.act_id || this.querys.act_id,
        award_id: -1,
        heybox_id: this.querys.heybox_id
      }).then(res => {
        if (res.data.status === 'ok') {
          utils.showMessage('ok', res.data.msg)
          this.state = 1
        } else {
          utils.showMessage('falid', res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.new-award {
  margin: 32px 14px 0;
  position: relative;
  .bg {
    width: 100%;
  }
  .receive-btn {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: absolute;
    bottom: 14px;
    left: 50%;
    transform: translateX(-50%);
    height: 36px;
    width: 125px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0.25px;
  }
}
</style>